import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';

@Component({
  selector: 'ds-lib-file-select',
  templateUrl: './ds-lib-file-select.component.html',
  styleUrls: ['./ds-lib-file-select.component.scss'],
})
export class DsLibFileSelectComponent {
  /**
   * Title displayed on the button
   */
  @Input() title = 'file-select';

  /**
   * Whether the component accepts multiple files
   */
  @Input() multiple = false;

  /**
   * Defines which types of files are accepted. Defaults to null = all files.
   * Ex: '.png', 'image/*', '.pdf'
   */
  @Input() accept: string = null;

  /**
   * Event emitted when file(s) has/have been selected
   */
  @Output() output = new EventEmitter<File[]>();

  /**
   * HTML form element. Used to reset the form after files have been selected.
   */
  @ViewChild('form', { static: true }) form;

  /**
   * Files to emit
   */
  files: File[];

  /**
   * Upon files selection validation, emits files and resets the component.
   *
   * @param event Event containing selected files/s
   */
  onValidation(event) {
    const files = event.srcElement.files;
    this.output.emit(files);
    this.form.nativeElement.reset();
  }
}
